// extracted by mini-css-extract-plugin
module.exports = {"root":"UnpauseAccount_root__1-9VY","icon":"UnpauseAccount_icon__3hMu7","text":"UnpauseAccount_text__32f26","btn":"UnpauseAccount_btn__2HVMB"};